import { call, put, takeLeading } from 'redux-saga/effects'
import * as fromActions from '../../actions/chat.action'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { getMessages } from 'api/chat/Get'

async function handleGetMessages({ courseId, identifier = 0 }: any) {
  return await getMessages(courseId, identifier)
}

function* getCourseMessagesEffectSaga(action: any) {
  try {
    const data = yield call(handleGetMessages, action.payload)
    yield put(fromActions.Actions.getChatMessagesSuccess(data))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* getCourseMessagesWatcherSaga() {
  yield takeLeading(fromActions.GET_CHAT_MESSAGES, getCourseMessagesEffectSaga)
}
